import sortBy from 'lodash/sortBy';

const cloneEntity = (entity) => JSON.parse(JSON.stringify(entity));

export default {
  getCurrentRTLoading(state) {
    return state.loading.current_rt;
  },
  getCurrentRT(state) {
    return state.currentRT;
  },
  summaryOverlayOpened(state) {
    return state.userInSummaryOverlay;
  },
  getRoundtableAuthor(state, { getCourseDetail }) {
    const author = getCourseDetail.users.find(
      (u) => u.id === state.currentRT.author_id
    );
    return (
      author || {
        id: null,
        name: null,
        avatar_url: null,
      }
    );
  },
  getMySubmission(state, { getMyRTUserDetails, getOrderedSubmissions }) {
    return getOrderedSubmissions.find(
      (submission) => submission.id === getMyRTUserDetails.submission_id
    );
  },
  getOrderedSubmissions(state, getters) {
    const { hasTeacherPermissionsInCourse, getCurrentRT, getMyRTUserDetails } = getters;
    const { enable_annonymous, reveal_names } = getCurrentRT;
    let submissions = cloneEntity(state.currentRT.submissions);
    const sort_conditions = [(submission) => !submission.is_pinned];
    if (!hasTeacherPermissionsInCourse) {
      sort_conditions.unshift((submission) => getMyRTUserDetails.id !== submission.user_id);
    }
    submissions = sortBy(submissions, sort_conditions);
    submissions.forEach((submission) => {
      if (!submission.teacher_submission) {
        if (enable_annonymous && !reveal_names) {
          submission.user = submission.anonymous_identity;
          Object.freeze(submission);
        }
      }
    });
    return submissions;
  },
  getSubmissionsBySubmitStatus(state, getters) {
    const allSubmissions = getters.getOrderedSubmissions;
    const filteredSubmissions = {
      submitted: [],
      by_passed: [],
      not_submitted: [],
    };
    allSubmissions.forEach((e) => {
      const isStartedResponse = e.start_date;
      if (isStartedResponse) {
        filteredSubmissions.submitted.push(e);
      } else if (e.by_pass_date) {
        filteredSubmissions.by_passed.push(e);
      } else {
        if (!e.teacher_submission) {
          filteredSubmissions.not_submitted.push(e);
        }
      }
    });
    return filteredSubmissions;
  },
  getClassSummary(state) {
    return state.grades.summary;
  },
  getStudentSummary(state) {
    return state.grades.student;
  },
  getStudentAssessments(state) {
    return state.grades.student.points_settings.peer_rewards.map((pr) => {
      const currentAssessment = state.grades.student.submission.assessments.find((a) => a.tag === pr.tag);
      return {
        tag: pr.tag,
        value: currentAssessment ? currentAssessment.value : 0,
        title: pr.title,
        feedback: currentAssessment ? currentAssessment.feedback : null
      };
    });
  },
  // LOADING
  getRTLoading(state) {
    return state.loading;
  },
  // state must be decalred so we can access getters
  studentInHardClosedRT(state, getters) {
    return !getters.hasTeacherPermissionsInCourse &&
      getters.getCurrentRT &&
      getters.getCurrentRT.is_ended &&
      getters.getCurrentRT.hard_close;
  },

  getRecentRtsList(state) {
    return state.recentRtsList;
  },
  getRecentInstructor(state) {
    return state.recent_instructor_roundtables;
  },
  getRecentParticipant(state) {
    return state.recent_participant_roundtables;
  }
};



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/onlineRoundtables.getters.js